/**
 * Ícones lineares da interface (Fase 1, padrão aprovado nos mockups): desenho fixo, sem conteúdo externo.
 * Herdam a cor do texto (stroke = currentColor) e são decorativos (aria-hidden) — o rótulo vem do elemento pai.
 */
const D = {
  inicio: '<path d="M3 11 12 4l9 7v9h-6v-6H9v6H3z"/>',
  tarefas: '<path d="M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2"/>',
  clientes: '<rect x="4" y="3" width="10" height="18" rx="1"/><path d="M14 9h5v12h-5M7 7h1M10 7h1M7 11h1M10 11h1M7 15h1M10 15h1"/>',
  contatos: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c0-3.5 2.9-6 6.5-6s6.5 2.5 6.5 6M16 4.5a3.5 3.5 0 0 1 0 7M21.5 20c0-3-1.8-5-4.5-5.7"/>',
  oportunidades: '<rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V4h6v3M3 12h18"/>',
  pedidos: '<path d="M3 4h2l2.5 11h11L21 7H7"/><circle cx="9" cy="19" r="1.5"/><circle cx="18" cy="19" r="1.5"/>',
  ordens: '<path d="M12 3 3 7.5v9L12 21l9-4.5v-9z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/>',
  receber: '<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/>',
  pagar: '<path d="M4 7h16v10H4zM8 12h8"/>',
  caixa: '<path d="M4 18l5-6 4 3 7-9"/>',
  parceiros: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/>',
  produtos: '<path d="M20 7 12 3 4 7l8 4z"/><path d="M4 7v10l8 4 8-4V7M12 11v10"/>',
  parametros: '<path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/>',
  usuarios: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c0-3.5 2.9-6 6.5-6s6.5 2.5 6.5 6M17 11l1.5 1.5L21 10"/>',
  cadastros: '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 9h8M8 13h8M8 17h5"/>',
  auditoria: '<path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M9 12l2 2 4-4"/>',
  recolher: '<path d="M15 6l-6 6 6 6M20 6v12"/>',
  expandir: '<path d="M9 6l6 6-6 6M4 6v12"/>',
  lupa: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
  filtro: '<path d="M4 5h16l-6 7v6l-4 2v-8z"/>',
  mais: '<path d="M12 5v14M5 12h14"/>',
  fechar: '<path d="M6 6l12 12M18 6 6 18"/>',
  usuario: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/>',
  sair: '<path d="M10 4H5v16h5M14 8l4 4-4 4M18 12H9"/>',
  grupo: '<circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c0-3.5 2.9-6 6.5-6s6.5 2.5 6.5 6M16 4.5a3.5 3.5 0 0 1 0 7M21.5 20c0-3-1.8-5-4.5-5.7"/>',
  ciclo: '<path d="M20 12a8 8 0 1 1-2.3-5.7M20 4v5h-5"/>',
  trofeu: '<path d="M8 4h8v6a4 4 0 0 1-8 0zM5 5H3a3 3 0 0 0 5 4M19 5h2a3 3 0 0 1-5 4M12 14v4M8 21h8"/>',
  documento: '<path d="M6 3h9l4 4v14H6z"/><path d="M9 12h6M9 16h4"/>',
  relogio: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7v5l3 2"/>',
  dinheiro: '<rect x="3" y="6" width="18" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9v.01M18 15v.01"/>',
  moedas: '<ellipse cx="12" cy="6" rx="7" ry="3"/><path d="M5 6v6c0 1.7 3 3 7 3s7-1.3 7-3V6M5 12v6c0 1.7 3 3 7 3s7-1.3 7-3v-6"/>',
  grafico: '<path d="M4 18l5-6 4 3 7-9M15 6h5v5"/>',
  queda: '<path d="M4 6l5 6 4-3 7 9M15 18h5v-5"/>',
  colunas: '<path d="M4 5h16v14H4zM9.5 5v14M14.5 5v14"/>',
  barras: '<path d="M5 20V11M12 20V5M19 20v-6M3 20h18"/>',
  alvo: '<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1"/>',
  etiqueta: '<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.2"/>',
  pizza: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5V12h8.5"/>',
  alerta: '<path d="M6 3h9l4 4v14H6z"/><path d="M12 10v4M12 17h.01"/>',
  caminhao: '<path d="M2 6h11v10H2zM13 9h4l4 4v3h-8z"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
  fatura: '<path d="M6 3h12v18l-3-2-3 2-3-2-3 2z"/><path d="M9 8h6M9 12h6"/>',
  lixeira: '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/>',
  predio: '<rect x="4" y="3" width="10" height="18" rx="1"/><path d="M14 9h5v12h-5M7 7h1M10 7h1M7 11h1M10 11h1M7 15h1M10 15h1"/>',
} as const;
export type NomeIcone = keyof typeof D;

export function Icone({ nome, className }: { nome: NomeIcone; className?: string }) {
  return <svg className={className ?? 'icone'} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" dangerouslySetInnerHTML={{ __html: D[nome] }} />;
}
